var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ams-table',{attrs:{"headers":_vm.showLogType ? _vm.headers : _vm.noOperateType,"value":_vm.logs}})}
var staticRenderFns = []

export { render, staticRenderFns }